import { useCmsPageAppearance } from "@/context/cms/CmsPageAppearanceContext";
import { useEffect } from "react";

type Props = {
  submitAll: () => void;
  isSaveDisabled?: boolean;
};

/** Registers CMSLayout save handlers for the Apparence drawer footer. */
export function CmsPageAppearanceSaveRegistrar({
  submitAll,
  isSaveDisabled,
}: Props) {
  const { registerSaveHandlers } = useCmsPageAppearance();

  useEffect(() => {
    registerSaveHandlers({ submitAll, isSaveDisabled });
    return () => registerSaveHandlers(null);
  }, [submitAll, isSaveDisabled, registerSaveHandlers]);

  return null;
}
